import { createContext } from "react";

export const themes = {
    dark : 'dark',
    ligth : 'ligth'
}

export const ThemeContext = createContext({});